/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaItem } from '../../models/media-item';

export interface IdentityControllerDeleteImage$Params {
  id: number;
}

export function identityControllerDeleteImage(http: HttpClient, rootUrl: string, params: IdentityControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerDeleteImage.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaItem;
      }>;
    })
  );
}

identityControllerDeleteImage.PATH = '/identity/{id}/picture';
